/*
  File: ss-card-atc.js
  Path: assets/ss-card-atc.js

  SanSCARi product card: Add to cart with a size picker.
  Works with snippets/ss-card-atc.liquid.

  What it does:
  1. Tap "Add to cart" on a card and the button turns into the sizes.
  2. Tap a size and that size is added to the cart.
  3. The theme's own cart drawer opens, same as on the product page.

  Markup it looks for (the snippet writes all of it):
  [data-ss-atc]          wrapper on each card
  [data-ss-atc-open]     the "Add to cart" button that reveals the sizes
  [data-ss-atc-sizes]    the row of sizes
  [data-ss-atc-add]      anything that adds a variant, with data-variant-id
  [data-ss-atc-msg]      where an error message is shown
*/
(function () {
  'use strict';

  if (window.SSCardAtc) return;

  var ROOT = '[data-ss-atc]';
  var openRoot = null;
  var msgTimer = null;

  function routes() {
    var r = window.routes || {};
    return {
      add: (r.cart_add_url || '/cart/add') + '.js',
      cart: r.cart_url || '/cart'
    };
  }

  function label(root, key, fallback) {
    return root.getAttribute('data-text-' + key) || fallback;
  }

  /* Open and close the size row ---------------------------------------- */

  function open(root) {
    if (openRoot && openRoot !== root) close(openRoot);
    var opener = root.querySelector('[data-ss-atc-open]');
    var sizes = root.querySelector('[data-ss-atc-sizes]');
    if (!opener || !sizes) return;
    hideMessage(root);
    opener.hidden = true;
    opener.setAttribute('aria-expanded', 'true');
    sizes.hidden = false;
    root.classList.add('is-open');
    openRoot = root;
    var first = sizes.querySelector('[data-ss-atc-add]:not([disabled])');
    if (first) {
      try {
        first.focus({ preventScroll: true });
      } catch (e) {
        first.focus();
      }
    }
  }

  function close(root, returnFocus) {
    if (!root) return;
    var opener = root.querySelector('[data-ss-atc-open]');
    var sizes = root.querySelector('[data-ss-atc-sizes]');
    if (sizes) sizes.hidden = true;
    if (opener) {
      opener.hidden = false;
      opener.setAttribute('aria-expanded', 'false');
      if (returnFocus) opener.focus();
    }
    root.classList.remove('is-open');
    if (openRoot === root) openRoot = null;
  }

  /* Messages ----------------------------------------------------------- */

  function showMessage(root, text) {
    var msg = root.querySelector('[data-ss-atc-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    window.clearTimeout(msgTimer);
    msgTimer = window.setTimeout(function () {
      msg.hidden = true;
    }, 6000);
  }

  function hideMessage(root) {
    var msg = root.querySelector('[data-ss-atc-msg]');
    if (msg) msg.hidden = true;
  }

  /* Add to cart -------------------------------------------------------- */

  function setBusy(root, trigger, busy) {
    root.classList.toggle('is-busy', busy);
    trigger.classList.toggle('is-loading', busy);
    if (busy) {
      trigger.setAttribute('aria-busy', 'true');
    } else {
      trigger.removeAttribute('aria-busy');
    }
  }

  function add(trigger) {
    var root = trigger.closest(ROOT);
    if (!root || root.classList.contains('is-busy')) return;

    var variantId = parseInt(trigger.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var url = routes();
    var errorText = label(root, 'error', 'Could not add this to your cart. Please try again.');

    /* The theme's cart drawer. If it is on the page we ask Shopify for its fresh HTML in the same request. */
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var canRender = !!(cart && typeof cart.getSectionsToRender === 'function' && typeof cart.renderContents === 'function');

    var payload = { id: variantId, quantity: 1 };
    if (canRender) {
      payload.sections = cart
        .getSectionsToRender()
        .map(function (section) {
          return section.id;
        })
        .join(',');
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(root.querySelector('[data-ss-atc-open]') || trigger);
      }
    }

    hideMessage(root);
    setBusy(root, trigger, true);

    fetch(url.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data || {} };
        });
      })
      .then(function (result) {
        var data = result.data;

        /* Shopify sends a status and a description when it refuses, for example when stock ran out */
        if (!result.ok || data.status) {
          showMessage(root, data.description || data.message || errorText);
          return;
        }

        close(root);

        try {
          document.dispatchEvent(new CustomEvent('ss:cart:add', { detail: { variantId: variantId, item: data } }));
        } catch (e) {}

        if (!canRender) {
          window.location.href = url.cart;
          return;
        }

        try {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } catch (e) {
          window.location.href = url.cart;
        }
      })
      .catch(function () {
        showMessage(root, errorText);
      })
      .then(function () {
        setBusy(root, trigger, false);
      });
  }

  /* Events: one listener for the whole page, so cards loaded later by "Load more" work too */

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var opener = target.closest('[data-ss-atc-open]');
    if (opener) {
      event.preventDefault();
      open(opener.closest(ROOT));
      return;
    }

    var adder = target.closest('[data-ss-atc-add]');
    if (adder) {
      event.preventDefault();
      if (!adder.disabled) add(adder);
      return;
    }

    /* A tap anywhere else puts the open card back to its button */
    if (openRoot && !target.closest(ROOT)) close(openRoot);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openRoot) close(openRoot, true);
  });

  window.SSCardAtc = { open: open, close: close };
})();